const buildStaticMessages = <A extends readonly string[]>(
  arr: A,
): { [key in A[number]]?: string } =>
  arr.reduce((accum, current) => {
    return {
      ...accum,
      [current]: `error:${current}`,
    }
  }, {})

const staticMessages = [
  'requiredField',
  'currencyNotFound',
  'serverError',
  'restricted',
  'banned',
  'emailNotFound',
  'emailIsAlreadyRegistered',
  'invalidConfirmationCode',
  'incorrectConfirmationCode',
  'needToAgreeTheUserAgreement',
  'youAlreadyHaveRegisteredAccount',
  'duplicateUserEmail',
  'socialUserNotFound',
  'socialNetworkCannotBeUnlinked',
  'invalidCredentials',
  'userBlocked',
] as const

const serverValidationMessages = [
  // Backend validation errors
  // 1****
  `RequiredField`,
  // 2****
  `MustBeString`,
  `InvalidEmail`,
  `InvalidCardNumber`,
  `InvalidAccountName`,
  `InvalidAccountNumber`,
  `InvalidIMPSIFSCCode`,
  `InvalidConfimationCode`,
  `InvalidPhoneNumber`,
  `MustBeStringArray`,
  `MustBeMatchNamePattern`,
  `MustBeMatchLoginPattern`,
  `InvalidWallet`,
  `InvalidCardHolderName`,
  // 3****
  `MustBeInteger`,
  `MustBePositiveInteger`,
  `MustBeFloat`,
  `MustBePositiveFloat`,
  `MustBeIntegerArray`,
  `MustBe1or2`,
  `MustBe1or2or3`,
  `MustBeMultiplied60Integer`,
  // 4****
  `MustBeISO8601`,
  `MustBeTimestamp`,
  `MustBeTimestampWithSec`,
  // 5****
  `MustBeBoolean`,
  `MustBeBooleanAsString`,
  `MustBeBooleanAsNumber`,
  // 6****
  `MustBeOneOfSort`,
  `MustBeOneOfGetTradesSort`,
  `MustBeOneOfGetUsersSort`,
  `MustBeOneOfGetWithdrawalsSort`,
  `MustBeOneOfGetUsersActionLogsSort`,
  `MustBeOneOfSymbolPosition`,
  `MustBeOneOfGetPromocodesSort`,
  `MustBeOneOfGetActivationsSort`,
  `MustBeOneOfPaymentTypes`,
  `MustBeOneOfOperationsTypes`,
  `MustBeOneOfStatisticSteps`,
  `MustBeOneOfPaykassmaWithdrawalActions`,
  `MustBeOneOfSocialNetworks`,
  `MustBeOneOfGenders`,
  // 7****
  `MustBe10Digits`,
  `Max32CharactersLong`,
  `Max512CharactersLong`,
  `Max255CharactersLong`,
  `Min10Max100Integer`,
  `MustBePasswordLengthChars`,
  `Max50CharactersLong`,
  // 8****
  `FileTooLarge`,
  `InvalidFileType`,
  `FileIsCorrupted`,
  `FileDimensionsExceed`,
  // 9****
  `InvalidPaymentTypeId`,
] as const

const builtMessages = {
  ...buildStaticMessages<typeof staticMessages>(staticMessages),
  ...buildStaticMessages<typeof serverValidationMessages>(serverValidationMessages),
}

export default builtMessages
